import React from "react";
import {Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend} from "chart.js";
import {Bar} from "react-chartjs-2";
import WasteSelectorTypes from "components/waste-icons/WasteSelectorTypes";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const AssetsFraction = ({data}) => {
    if (!data) return null;

    const fractionTypes = Object.keys(data.fractions);

    const labels = fractionTypes.map((type) => data.fractions[type].name);

    const datasets = [];

    fractionTypes.forEach((type) => {
        let backgroundColor, borderColor;

        if (WasteSelectorTypes[type]) {
            backgroundColor = WasteSelectorTypes.getBackgroundColor(type);
            borderColor = WasteSelectorTypes.getBorderColor(type);
        } else {
            const fractionColors = {
                pg: "#FFCC00", // Envases - Amarillo
                oc: "#8B4513", // Orgánico - Marrón
                pc: "#0066CC", // Papel - Azul
                gl: "#33CC33", // Vidrio - Verde
                rg: "#999999", // Reciclado - Gris
            };
            backgroundColor = fractionColors[type] || "#999999";
            borderColor = "#707070";
        }

        const dataValues = Array(fractionTypes.length).fill(0);
        const index = fractionTypes.indexOf(type);
        dataValues[index] = data.fractions[type].count;

        datasets.push({
            label: data.fractions[type].name,
            data: dataValues,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            borderWidth: 1,
        });
    });

    const DataBar = {
        labels: labels,
        datasets: datasets,
    };

    const OptionsBar = {
        responsive: true,
        plugins: {
            legend: {
                position: "top",
                labels: {
                    usePointStyle: true,
                    pointStyle: "rect",
                    font: {
                        size: 12,
                    },
                },
            },
            title: {
                display: true,
                text: "Numero de contenedores según fracción",
                font: {
                    size: 16,
                },
            },
            tooltip: {
                callbacks: {
                    label: (tooltipItem) => {
                        if (tooltipItem.raw === 0) return null;
                        return `${tooltipItem.dataset.label}: ${tooltipItem.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                stacked: true,
            },
            y: {
                stacked: true,
            },
        },
    };

    return (
        <div className="">
            <div className="border pb-3" style={{height: "365px"}}>
                <Bar data={DataBar} options={OptionsBar} />
            </div>
        </div>
    );
};

export default AssetsFraction;
